import { RawCarData } from 'api/cars'
import { createMask } from 'imask'
import { createPluralFormWithPlaceholder } from 'lib/pluralize'

import { CarViewSettings } from '../types'
/**
 * Определяет под каким холдингом находятся дилеры. Если поле short_name у всех дилеров совпдает,
 * то они находятся под одним холдингом.
 * @param {object} dealers
 * @return {string|null} Название холдинга или null, если дилеры не входят в один холдинг
 */
const getCommonHolding = (dealers: RawCarData['dealers']) => {
  if (dealers.length === 0) return null
  const referenceDealer = dealers[0]
  if (!('short_name' in referenceDealer)) return null
  const hasOneHolding = dealers.every((dealer) => dealer.short_name === referenceDealer.short_name)
  return hasOneHolding ? referenceDealer.short_name : null
}
/**
 * Возврщает строку с городами через запятую
 */
export const getStringFromCities = (cities: RawCarData['cities']) => {
  return cities.map((city) => city.name).join(', ')
}
/**
 * Создаёт описание местоположения машины - города, дилеры, группировка по холдингу
 * @param car
 * @param carViewSettings
 */
export const createLocationDescription = (car: RawCarData, carViewSettings: CarViewSettings) => {
  if (carViewSettings.showLocationAs === 'cities') {
    return getStringFromCities(car.cities)
  } else {
    const commonDealer = getCommonHolding(car.dealers)
    const numberOfDealers = createPluralFormWithPlaceholder(carViewSettings.i18n.dealers, car.dealers.length)

    if (commonDealer) return car.dealers.length === 1 ? `${commonDealer}` : `${commonDealer} (${numberOfDealers})`

    if (car.dealers.length === 1) return car.dealers[0].name

    return createPluralFormWithPlaceholder(carViewSettings.i18n.carAvaiableInDealerships, car.dealers.length)
  }
}
/**
 * Определяет какой номер телефона нужно показывать
 * Если все дилеры принадлежат одному холдингу или дилер всего один, используем телефон первого дилера, иначе телефон не может быть определён
 * @param car
 * @param carViewSettings
 */
export const createLocationPhone = (car: RawCarData, carViewSettings: CarViewSettings): string | undefined => {
  if (carViewSettings.showPhoneInLocation && (getCommonHolding(car.dealers) || car.dealers.length === 1)) {
    if (car.dealers[0].phone) {
      return createMask({ mask: carViewSettings.i18n.phoneMask }).resolve(car.dealers[0].phone)
    }
  }
  return
}
